/**
 * Configuration constants for Resource Board module
 */

export const RESOURCE_BOARD_CONFIG = {
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_URL?.replace(/\/$/, '') || 'https://login.entrigy.com',
    timeout: 30000, // 30 seconds
    retryAttempts: 3
  },

  // Socket.IO Configuration
  socket: {
    url: process.env.REACT_APP_SOCKET_URL?.replace(/\/$/, '')
      || (process.env.REACT_APP_API_URL?.replace(/\/$/, '').replace(/:\d+$/, ':4000'))
      || 'https://login.entrigy.com',
    boardId: 'resource-board', // Shared room ID for the resource board
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  },

  // Real-time Collaboration
  collaboration: {
    cursorThrottleMs: 100,    // Throttle cursor broadcasts (~10fps)
    cursorStaleMs: 15000,     // Remove cursor after 15s of inactivity
    enabled: true,            // Global enable/disable switch
  },

  // Timeline Configuration
  timeline: {
    hourWidth: 100,
    defaultView: 'month',
    views: ['month', 'quarter', 'half-year'],
    minZoom: 0.5,
    maxZoom: 2.0
  },

  // Undo/Redo Configuration
  history: {
    maxUndoSteps: 10,
    autoSaveInterval: 30000 // 30 seconds
  },

  // Drag and Drop Configuration
  dragDrop: {
    scrollSpeed: 20,
    scrollThreshold: 50,
    snapToGrid: true,
    gridSize: 10
  },

  // Filter Configuration
  filters: {
    defaultPageSize: 50,
    maxResults: 1000
  },

  // Date Configuration
  dates: {
    format: 'yyyy-MM-dd',
    displayFormat: 'MMM dd, yyyy',
    firstDayOfWeek: 1 // Monday
  },

  // Performance Configuration
  performance: {
    debounceDelay: 300,
    throttleDelay: 100,
    lazyLoadThreshold: 10
  },

  // Color Schemes
  colors: {
    projects: [
      '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
      '#8B5CF6', '#EC4899', '#14B8A6', '#F97316'
    ],
    roles: [
      { name: 'Manager', color: '#DC2626' },
      { name: 'Engineer', color: '#2563EB' },
      { name: 'Worker', color: '#059669' },
      { name: 'Driver', color: '#D97706' }
    ]
  },

  // Validation Rules
  validation: {
    minAssignmentDuration: 1, // days
    maxAssignmentDuration: 365, // days
    maxCarCapacity: 8
  },

  // Status Configuration
  assignmentStatuses: [
    { value: 'pending', label: 'Pending', color: 'gray' },
    { value: 'confirmed', label: 'Confirmed', color: 'blue' },
    { value: 'in_progress', label: 'In Progress', color: 'yellow' },
    { value: 'completed', label: 'Completed', color: 'green' },
    { value: 'cancelled', label: 'Cancelled', color: 'red' }
  ],

  // Travel Types
  travelTypes: [
    { value: 'check_in', label: 'Check-in', icon: 'plane-arrival' },
    { value: 'check_out', label: 'Check-out', icon: 'plane-departure' },
    { value: null, label: 'Not a travel', icon: null }
  ]
};

export default RESOURCE_BOARD_CONFIG;
